export type ImageResolution =
  | 'responsive'
  | 'original'
  | 'milli'
  | 'md'
  | 'lg'
  | 'xl'
  | 'fhd'
  | 'none';

export const IMAGE_RESOLUTION: Record<ImageResolution, string> = {
  responsive: 'Responsive',
  original: 'Original',
  milli: 'Milli',
  md: 'MD',
  lg: 'LG',
  xl: 'XL',
  fhd: 'FHD',
  none: 'none',
};

export type ImageFit = 'cover' | 'contain' | 'fill' | 'scale-down' | 'none';

/**
 * Intrinsic pixel width of every generated image variation.
 * Used to build `srcset` width descriptors so the browser can pick the right
 * variation from the *rendered* size of the element (not the viewport).
 *
 * Keep these numbers in sync with the variation widths produced by the backend.
 */
export const IMAGE_RESOLUTION_WIDTH: Partial<Record<ImageResolution, number>> = {
  milli: 96,
  md: 512,
  lg: 1024,
  xl: 1440,
  fhd: 1920,
  original: 2560,
};
